import {
  ACTION_FAMILY,
  type ActionType,
  type ExplicitActionType,
} from "./action-types";

export const ACTION_CATEGORIES = {
  [ACTION_FAMILY.transfer]: ["erc20_transfer", "native_transfer"],
  [ACTION_FAMILY.yieldWithdraw]: [
    "erc4626_withdraw",
    "fluid_vault_withdraw",
    "morpho_vault_withdraw",
    "aave_v3_withdraw",
    "aave_v3_gateway_withdraw",
    "weth_unwrap",
  ],
  [ACTION_FAMILY.yieldRedeem]: [
    "erc4626_redeem",
    "fluid_vault_redeem",
    "morpho_vault_redeem",
    "aave_v3_withdraw",
  ],
  [ACTION_FAMILY.swap]: [
    "lifi_swap",
    "relay_swap",
    "bebop_rfq_swap",
    "bebop_jam_swap",
    "ondo_direct_mint_redeem",
    "ondo_direct_batch_rebalance",
    "reality_via_bitget_swap",
    "zeroex_swap",
  ],
  [ACTION_FAMILY.bridge]: ["lifi_bridge", "relay_bridge"],
  [ACTION_FAMILY.yieldDeposit]: [
    "erc4626_deposit",
    "fluid_vault_deposit",
    "morpho_vault_deposit",
    "aave_v3_deposit",
    "aave_v3_gateway_deposit",
    "weth_wrap",
  ],
  [ACTION_FAMILY.liquidity]: [
    "cl_mint",
    "cl_increase",
    "cl_decrease",
    "cl_collect",
    "cl_burn",
  ],
  [ACTION_FAMILY.call]: ["evm_call"],
} as const satisfies Record<ActionType, readonly ExplicitActionType[]>;

export const getCategoryCandidates = (
  actionType: ActionType,
): readonly ExplicitActionType[] => ACTION_CATEGORIES[actionType];
